"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  TRANSMIT_CONFIG_QUERY_PARAM: "loadExternalConfig",
  LEGACY_TRANSMIT_CONFIG_QUERY_PARAM: "delayedRender",
  MAX_LOAD_WAIT_TIME: 5 * 1000,
  // ms
  // Whitelisted hostnames allowed to init app with custom config
  // - `(.+\.)?` prefix denotes subdomain inclusion
  NIB_HOSTNAME_WHITELIST: [/(.+\.)?nib\.co\.nz$/, /(.+\.)?nib\.com\.au$/, /(.+\.)?nib-cf-test\.com$/, /(.+\.)?optimizely.com$/],
  GU_HOSTNAME_WHITELIST: [/(.+\.)?guhealth\.com\.au$/, /(.+\.)?guhealth-test\.com$/],
  // The acceptable threshold to accept active session timestamps within
  ACTIVE_CHAT_TIMESTAMP_ACCEPTABLE_THRESHOLD: 24 * 60 * 60 * 1000,
  // hours
  POP_OUT_ACTIVE_TIMESTAMP_ACCEPTABLE_THRESHOLD: 60 * 1000,
  // seconds
  // How often the timestamp is set/updated
  ACTIVE_CHAT_TIMESTAMP_SET_INTERVAL: 5000,
  // ms
  POP_OUT_ACTIVE_TIMESTAMP_SET_INTERVAL: 5000 // ms
};